import FilterBox from './FilterBox.vue';

export default FilterBox;
